<template>
  <div class="app-container">
    <!-- 搜索栏 -->
    <el-card class="search-card" shadow="never">
      <el-form :model="queryParams" ref="queryForm" :inline="true" label-width="100px">
        <el-form-item label="活动名称" prop="title">
          <el-input
                  v-model="queryParams.title"
                  placeholder="请输入活动名称"
                  clearable
                  style="width: 200px"
                  @keyup.enter.native="handleQuery"
          />
        </el-form-item>

        <el-form-item label="活动状态" prop="status">
          <el-select v-model="queryParams.status" placeholder="请选择状态" clearable style="width: 120px">
            <el-option label="全部" value="" />
            <el-option label="未开始" :value="0" />
            <el-option label="进行中" :value="1" />
            <el-option label="已结束" :value="2" />
            <el-option label="已暂停" :value="3" />
          </el-select>
        </el-form-item>

        <el-form-item label="活动时间">
          <el-date-picker
                  v-model="dateRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  style="width: 240px"
          />
        </el-form-item>

        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
          <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 统计卡片 -->
    <el-row :gutter="20" class="stats-row">
      <el-col :span="6">
        <el-card shadow="hover" class="stats-card">
          <div class="stats-content">
            <div class="stats-icon" style="background: #36a3f7;">
              <i class="el-icon-shopping-bag-1"></i>
            </div>
            <div class="stats-info">
              <div class="stats-title">进行中活动</div>
              <div class="stats-value">{{ stats.runningCount }}</div>
            </div>
          </div>
        </el-card>
      </el-col>

      <el-col :span="6">
        <el-card shadow="hover" class="stats-card">
          <div class="stats-content">
            <div class="stats-icon" style="background: #34bfa3;">
              <i class="el-icon-shopping-cart-2"></i>
            </div>
            <div class="stats-info">
              <div class="stats-title">今日订单</div>
              <div class="stats-value">{{ stats.todayOrders }}</div>
            </div>
          </div>
        </el-card>
      </el-col>

      <el-col :span="6">
        <el-card shadow="hover" class="stats-card">
          <div class="stats-content">
            <div class="stats-icon" style="background: #f4516c;">
              <i class="el-icon-trophy-1"></i>
            </div>
            <div class="stats-info">
              <div class="stats-title">成团率</div>
              <div class="stats-value">{{ stats.successRate }}%</div>
            </div>
          </div>
        </el-card>
      </el-col>

      <el-col :span="6">
        <el-card shadow="hover" class="stats-card">
          <div class="stats-content">
            <div class="stats-icon" style="background: #ffb822;">
              <i class="el-icon-money"></i>
            </div>
            <div class="stats-info">
              <div class="stats-title">今日销售额</div>
              <div class="stats-value">¥{{ stats.todaySales }}</div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 操作栏 -->
    <el-card class="operate-card" shadow="never">
      <el-row :gutter="10" class="mb8">
        <el-col :span="1.5">
          <el-button
              size="mini"
                  type="primary"
                  icon="el-icon-plus"
                  @click="handleAdd"

          >
            新增活动
          </el-button>
        </el-col>
        <el-col :span="1.5">
          <el-button
              size="mini"
                  type="success"
                  icon="el-icon-edit"
                  :disabled="single"
                  @click="handleUpdate"

          >
            修改
          </el-button>
        </el-col>
        <el-col :span="1.5">
          <el-button
              size="mini"
                  type="danger"
                  icon="el-icon-delete"
                  :disabled="multiple"
                  @click="handleDelete"

          >
            删除
          </el-button>
        </el-col>
        <el-col :span="1.5">
          <el-button
              size="mini"
                  type="warning"
                  icon="el-icon-download"
                  @click="handleExport"

          >
            导出
          </el-button>
        </el-col>

        <!-- 活动状态批量操作 -->
        <el-col :span="2">
          <el-dropdown  size="mini" @command="handleBatchCommand">
            <el-button  size="mini">
              批量操作<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="batchStart" icon="el-icon-video-play">
                批量开始
              </el-dropdown-item>
              <el-dropdown-item command="batchPause" icon="el-icon-video-pause">
                批量暂停
              </el-dropdown-item>
              <el-dropdown-item command="batchEnd" icon="el-icon-switch-button">
                批量结束
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-col>
      </el-row>
    </el-card>

    <!-- 活动列表 -->
    <el-card class="table-card" shadow="never">
      <el-table
          size="mini"
              :data="activityList"
              @selection-change="handleSelectionChange"
              @sort-change="handleSortChange"
      >
        <el-table-column type="selection" width="55" align="center" />

        <el-table-column label="活动封面" align="center" width="120">
          <template slot-scope="scope">
            <div class="activity-cover">
              <el-image
                      :src="scope.row.coverImage"
                      fit="cover"
                      class="cover-image"
                      :preview-src-list="[scope.row.coverImage]"
              >
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </div>
          </template>
        </el-table-column>

        <el-table-column
                label="活动名称"
                align="center"
                prop="title"
                width="200"
                :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <div class="activity-title">
              <span class="title-text">{{ scope.row.title }}</span>
              <div class="goods-name">
                <el-tag size="mini">{{ scope.row.goodsName }}</el-tag>
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="拼团设置" align="center" width="150">
          <template slot-scope="scope">
            <div class="group-setting">
              <div class="group-price">¥{{ scope.row.groupPrice }}</div>
              <div class="group-size">{{ scope.row.groupSize }}人团</div>
              <div class="valid-hours">有效期{{ scope.row.validHours }}小时</div>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="库存/销量" align="center" width="140">
          <template slot-scope="scope">
            <div class="stock-sales">
              <el-progress

              :percentage="Math.min(100, Math.max(0, Math.round((scope.row.usedStock || 0) / ((scope.row.totalStock || 1)) * 100)))"
              :color="getProgressColor(Math.min(100, Math.max(0, Math.round((scope.row.usedStock || 0) / ((scope.row.totalStock || 1)) * 100))))"
              :show-text="false"
              />
              <div class="stock-info">
                <span>库存：{{ scope.row.totalStock - scope.row.usedStock }}/{{ scope.row.totalStock }}</span>
                <span>销量：{{ scope.row.actualSales }}</span>
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="成团数据" align="center" width="150">
          <template slot-scope="scope">
            <div class="group-data">
              <div class="success-rate">
                <i class="el-icon-success"></i>
                成团率：{{ scope.row.successRate }}%
              </div>
              <div class="team-count">
                <i class="el-icon-user"></i>
                进行中：{{ scope.row.runningTeams }}
              </div>
              <div class="success-count">
                <i class="el-icon-trophy"></i>
                已成功：{{ scope.row.successTeams }}
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="活动时间" align="center" width="220">
          <template slot-scope="scope">
            <div class="activity-time">
              <div>开始：{{ scope.row.startTime|dateFormat  }}</div>
              <div>结束：{{ scope.row.endTime|dateFormat }}</div>
              <div v-if="scope.row.status === 1" class="time-remain">
                <el-tag size="mini" type="warning">
                  剩余{{ getTimeRemain(scope.row.endTime) }}
                </el-tag>
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="活动状态" align="center" width="100">
          <template slot-scope="scope">
            <el-tag
                    :type="getStatusType(scope.row.status)"
                    size="medium"
                    effect="dark"
            >
              {{ getStatusText(scope.row.status) }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center" width="250" class-name="small-padding fixed-width">
          <template slot-scope="scope">
            <el-button
                    type="text"
                    icon="el-icon-view"
                    @click="handleView(scope.row)"
                    size="mini"
            >
              查看
            </el-button>
            <el-button
                    type="text"
                    icon="el-icon-edit"
                    @click="handleUpdate(scope.row)"
                    size="mini"
            >
              编辑
            </el-button>

            <!-- 状态操作 -->
            <el-dropdown  size="mini" @command="(command) => handleStatusCommand(command, scope.row)">
              <el-button type="text"  size="mini">
                状态<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                        v-if="scope.row.status === 0"
                        command="start"
                        icon="el-icon-video-play"
                >
                  开始活动
                </el-dropdown-item>
                <el-dropdown-item
                        v-if="scope.row.status === 1"
                        command="pause"
                        icon="el-icon-video-pause"
                >
                  暂停活动
                </el-dropdown-item>
                <el-dropdown-item
                        v-if="scope.row.status !== 2"
                        command="end"
                        icon="el-icon-switch-button"
                >
                  结束活动
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

            <!-- 更多操作 -->
            <el-dropdown size="mini" @command="(command) => handleMoreCommand(command, scope.row)">
              <el-button type="text" size="mini">
                更多<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown" size="mini">
                <el-dropdown-item command="teams" icon="el-icon-user">
                  拼团团队
                </el-dropdown-item>
                <el-dropdown-item command="orders" icon="el-icon-s-order">
                  活动订单
                </el-dropdown-item>
                <el-dropdown-item command="statistics" icon="el-icon-data-analysis">
                  数据统计
                </el-dropdown-item>
                <el-dropdown-item command="copy" icon="el-icon-copy-document">
                  复制活动
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>

      <div class="block" style="margin-top:10px">
        <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="queryParams.pageNum"
            :page-sizes="[10, 20, 30, 100]"
            :page-size="queryParams.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
      </div>

      <!-- 分页 -->

    </el-card>

    <!-- 添加或修改活动对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="900px" append-to-body>
      <el-form ref="form" :model="form" :rules="rules" label-width="120px">
        <el-tabs v-model="activeTab">
          <!-- 活动信息 -->
          <el-tab-pane label="活动信息" name="info">
            <el-form-item label="活动名称" prop="title">
              <el-input v-model="form.title" placeholder="请输入活动名称" />
            </el-form-item>

            <el-form-item label="关联商品" prop="goodsId">

              <el-select
                  v-model="form.goodsId"
                  placeholder="请选择商品"
                  filterable
                  remote
                  :remote-method="searchGoods"
                  :loading="goodsLoading"
                  style="width: 100%"
                  @change="handleGoodsChange"
                  clearable
              >
              <el-option
                  v-for="item in goodsOptions"
                  :key="item.id"
              :label="item.title"
              :value="item.id"
              >
              <div class="goods-option">
                <!-- 修复：处理 images 为空的情况，避免报错 -->
                <el-image
                    :src="item.images && item.images.length > 0 ? item.images[0] : ''"
                    style="width: 40px; height: 40px; margin-right: 10px"
                    fit="cover"
                    :alt="item.title"
                />
                <div class="goods-info">
                  <div class="goods-title">{{ item.title }}</div>
                  <div class="goods-price">
                    <span>原价：¥{{ item.originalPrice || 0 }}</span>
                    <span style="margin-left: 10px">现价：¥{{ item.currentPrice || 0 }}</span>
                  </div>
                </div>
              </div>
              </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="活动封面" prop="coverImage">
              <el-upload
                      class="cover-uploader"
                      action="#"
                      :show-file-list="false"
                      :before-upload="beforeCoverUpload"
                      :on-change="handleCoverChange"
              >
                <img v-if="form.coverImage" :src="form.coverImage" class="cover-image-preview" />
                <div v-else class="cover-uploader-trigger">
                  <i class="el-icon-plus"></i>
                  <div>上传封面</div>
                </div>
              </el-upload>
              <div class="cover-tip">建议尺寸800*400，支持jpg/png格式</div>
            </el-form-item>

            <el-form-item label="活动时间" prop="activityTime">
              <el-date-picker
                      v-model="form.activityTime"
                      type="datetimerange"
                      range-separator="至"
                      start-placeholder="开始时间"
                      end-placeholder="结束时间"
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      :default-time="['00:00:00', '23:59:59']"
                      style="width: 100%"
              />
            </el-form-item>

            <el-form-item label="拼团价" prop="groupPrice">
              <el-input-number
                  v-model="form.groupPrice"
                  :min="0"
                  :precision="2"
                  :step="0.1"
                  controls-position="right"
                  style="width: 100%"
                  placeholder="拼团价"
              />
            </el-form-item>
            <el-form-item label="成团人数" prop="groupSize">
              <el-input-number
                  v-model="form.groupSize"
                  :min="2"
                  :max="100"
                  controls-position="right"
                  style="width: 100%"
                  placeholder="成团人数"
              />
            </el-form-item>
            <el-form-item label="有效期(小时)" prop="validHours">

              <el-input-number
                  v-model="form.validHours"
                  :min="1"
                  :max="720"
                  controls-position="right"
                  style="width: 100%"
                  placeholder="有效期"
              />
            </el-form-item>

            <el-form-item label="限购数量" prop="limitNum">
              <el-input-number
                      v-model="form.limitNum"
                      :min="0"
                      controls-position="right"
                      placeholder="0表示不限购"
                      style="width: 200px"
              />
              <span class="limit-tip">0表示不限购</span>
            </el-form-item>

            <el-form-item label="总库存" prop="totalStock">
              <el-input-number
                      v-model="form.totalStock"
                      :min="1"
                      controls-position="right"
                      style="width: 200px"
              />
            </el-form-item>

            <el-form-item label="虚拟销量" prop="virtualSales">
              <el-input-number
                      v-model="form.virtualSales"
                      :min="0"
                      controls-position="right"
                      style="width: 200px"
              />
              <span class="sales-tip">设置初始销量，增加活动热度</span>
            </el-form-item>
          </el-tab-pane>

          <!-- 商品信息 -->
          <el-tab-pane label="商品信息" name="goods">
            <div v-if="selectedGoods" class="goods-detail">
              <el-row :gutter="20">
                <el-col :span="8">
                  <!-- 修复：添加 ?. 保护，避免 images 为 null/undefined 时报错 -->
                  <el-image
                      :src="selectedGoods.images?.[0] ?? ''"
                      fit="cover"
                      style="width: 100%; height: 200px"
                      :preview-src-list="selectedGoods.images ?? []"
                  />
                </el-col>
                <el-col :span="16">
                  <div class="goods-info">
                    <h3 class="goods-title">{{ selectedGoods.title }}</h3>
                    <div class="goods-price">
                      <div class="price-item">
                        <span class="price-label">原价：</span>
                        <span class="original-price">¥{{ selectedGoods.originalPrice }}</span>
                      </div>
                      <div class="price-item">
                        <span class="price-label">现价：</span>
                        <span class="current-price">¥{{ selectedGoods.currentPrice }}</span>
                      </div>
                      <div class="price-item">
                        <span class="price-label">默认拼团价：</span>
                        <span class="group-price">¥{{ selectedGoods.groupPrice }}</span>
                      </div>
                    </div>
                    <div class="goods-spec">
                      <div class="spec-title">商品规格：</div>
                      <div v-if="selectedGoods.specs && selectedGoods.specs.length > 0">
                        <el-tag
                                v-for="spec in selectedGoods.specs"
                                :key="spec.id"
                                size="small"
                                style="margin-right: 5px"
                        >
                          {{ spec.name }}
                        </el-tag>
                      </div>
                      <div v-else class="no-spec">无规格</div>
                    </div>
                    <div class="goods-stock">
                      <div>库存：{{ selectedGoods.stock }}</div>
                      <div style="margin-left: 20px">销量：{{ selectedGoods.sales }}</div>
                    </div>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div v-else class="no-goods">
              <i class="el-icon-goods"></i>
              <div>请先选择关联商品</div>
            </div>
          </el-tab-pane>

          <!-- SKU设置 -->
          <el-tab-pane label="SKU设置" name="sku" v-if="selectedGoods && selectedGoods.skus && selectedGoods.skus.length > 0">
            <el-table :data="skuList" border style="width: 100%">
              <el-table-column label="规格组合" prop="specData" width="200">
                <template slot-scope="scope">
                  <div class="sku-spec">
                    <span v-for="(value, key) in scope.row.specData" :key="key">
                      {{ value }}
                    </span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="原价" prop="price" width="100">
                <template slot-scope="scope">
                  ¥{{ scope.row.price }}
                </template>
              </el-table-column>
              <el-table-column label="拼团价" width="150">
                <template slot-scope="scope">
                  <el-input-number
                          v-model="scope.row.groupPrice"
                          :min="0"
                          :precision="2"
                          :step="0.1"
                          size="small"
                          controls-position="right"
                          style="width: 120px"
                  />
                </template>
              </el-table-column>
              <el-table-column label="活动库存" width="150">
                <template slot-scope="scope">
                  <el-input-number
                          v-model="scope.row.stock"
                          :min="0"
                          :max="scope.row.originalStock"
                          size="small"
                          controls-position="right"
                          style="width: 120px"
                  />
                  <div class="stock-tip">总库存：{{ scope.row.originalStock }}</div>
                </template>
              </el-table-column>
              <el-table-column label="状态" width="100">
                <template slot-scope="scope">
                  <el-switch
                          v-model="scope.row.status"
                          :active-value="1"
                          :inactive-value="0"
                  />
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>

    <!-- 活动详情对话框 -->
    <el-dialog title="活动详情" :visible.sync="detailOpen" width="1000px" append-to-body>
      <div v-if="detailData" class="activity-detail-dialog">
        <!-- 活动基本信息 -->
        <div class="detail-section">
          <h3 class="section-title">活动基本信息</h3>
          <el-row :gutter="20">
            <el-col :span="8">
              <div class="cover-container">
                <el-image
                        :src="detailData.coverImage"
                        fit="cover"
                        style="width: 100%; height: 200px"
                />
              </div>
            </el-col>
            <el-col :span="16">
              <el-descriptions :column="2" border>
                <el-descriptions-item label="活动名称">{{ detailData.title }}</el-descriptions-item>
                <el-descriptions-item label="关联商品">{{ detailData.goodsName }}</el-descriptions-item>
                <el-descriptions-item label="活动状态">
                  <el-tag :type="getStatusType(detailData.status)" effect="dark">
                    {{ getStatusText(detailData.status) }}
                  </el-tag>
                </el-descriptions-item>
                <el-descriptions-item label="成团率">{{ detailData.successRate }}%</el-descriptions-item>
                <el-descriptions-item label="拼团价">¥{{ detailData.groupPrice }}</el-descriptions-item>
                <el-descriptions-item label="成团人数">{{ detailData.groupSize }}人</el-descriptions-item>
                <el-descriptions-item label="活动时间">
                  {{ detailData.startTime|dateFormat }} 至 {{ detailData.endTime|dateFormat}}
                </el-descriptions-item>
                <el-descriptions-item label="剩余库存">{{ detailData.totalStock - detailData.usedStock }}/{{ detailData.totalStock }}</el-descriptions-item>
              </el-descriptions>
            </el-col>
          </el-row>
        </div>

        <!-- 实时数据 -->
        <div class="detail-section">
          <h3 class="section-title">实时数据</h3>
          <el-row :gutter="20">
            <el-col :span="6">
              <div class="data-card">
                <div class="data-icon" style="background: #36a3f7;">
                  <i class="el-icon-shopping-bag-1"></i>
                </div>
                <div class="data-content">
                  <div class="data-label">参与人数</div>
                  <div class="data-value">{{ detailData.joinCount }}</div>
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="data-card">
                <div class="data-icon" style="background: #34bfa3;">
                  <i class="el-icon-shopping-cart-2"></i>
                </div>
                <div class="data-content">
                  <div class="data-label">订单数量</div>
                  <div class="data-value">{{ detailData.orderCount }}</div>
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="data-card">
                <div class="data-icon" style="background: #f4516c;">
                  <i class="el-icon-trophy-1"></i>
                </div>
                <div class="data-content">
                  <div class="data-label">成团数量</div>
                  <div class="data-value">{{ detailData.successTeams }}</div>
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="data-card">
                <div class="data-icon" style="background: #ffb822;">
                  <i class="el-icon-money"></i>
                </div>
                <div class="data-content">
                  <div class="data-label">销售额</div>
                  <div class="data-value">¥{{ detailData.salesAmount }}</div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>

        <!-- 团队列表 -->
        <div class="detail-section">
          <h3 class="section-title">拼团团队列表</h3>
          <el-table :data="detailData.teams" border style="width: 100%">
            <el-table-column label="团队编号" prop="teamNo" width="140" />
            <el-table-column label="团长" width="120">
              <template slot-scope="scope">
                <div class="leader-info">
                  <el-avatar :src="scope.row.leaderAvatar" size="small" />
                  <span style="margin-left: 5px">{{ scope.row.leaderName }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="团队状态" width="100">
              <template slot-scope="scope">
                <el-tag
                        :type="scope.row.status === 1 ? 'success' : scope.row.status === 2 ? 'danger' : 'warning'"
                        size="small"
                >
                  {{ scope.row.status === 0 ? '拼团中' : scope.row.status === 1 ? '成功' : '失败' }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="进度" width="150">
              <template slot-scope="scope">
                <el-progress
                        :percentage="Math.round((scope.row.currentSize / scope.row.groupSize) * 100)"
                        :color="scope.row.status === 1 ? '#67c23a' : scope.row.status === 2 ? '#f56c6c' : '#e6a23c'"
                />
              </template>
            </el-table-column>
            <el-table-column label="剩余时间" width="120">
              <template slot-scope="scope">
                <div v-if="scope.row.status === 0">
                  {{ getTimeRemain(scope.row.expireTime) }}
                </div>
                <div v-else>-</div>
              </template>
            </el-table-column>
            <el-table-column label="创建时间" prop="createTime" width="160" />
            <el-table-column label="操作" width="100">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="viewTeamDetail(scope.row)">
                  查看详情
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 订单趋势图 -->
        <div class="detail-section">
          <h3 class="section-title">订单趋势</h3>
          <div ref="orderChart" style="height: 300px;"></div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  // import { listActivity, getActivity, delActivity, addActivity, updateActivity, changeActivityStatus, getActivityStats } from '@/api/activity'
  // import { listGoods } from '@/api/goods'


  import * as echarts from 'echarts'
  import moment from "moment/moment";
  export default {
    name: 'activityList',
    data() {
      return {
        // 遮罩层
        loading: true,
        // 选中数组
        ids: [],
        // 非单个禁用
        single: true,
        // 非多个禁用
        multiple: true,
        // 总条数
        total: 0,
        // 活动表格数据
        activityList: [],
        // 统计信息
        stats: {
          runningCount: 0,
          todayOrders: 0,
          successRate: 0,
          todaySales: 0
        },
        // 日期范围
        dateRange: [],
        // 查询参数
        queryParams: {
          pageNum: 1,
          pageSize: 10,
          title: undefined,
          status: undefined
        },
        // 表单参数
        form: {
          id: undefined,
          title: undefined,
          goodsId: undefined,
          coverImage: undefined,
          groupPrice: undefined,
          groupSize: 2,
          validHours: 24,
          limitNum: 0,
          totalStock: 100,
          virtualSales: 0,
          activityTime: [],
          skus: []
        },
        // 商品选项
        goodsOptions: [],
        // 商品加载状态
        goodsLoading: false,
        // 选中的商品
        selectedGoods: null,
        // SKU列表
        skuList: [],
        // 表单校验
        rules: {
          title: [
            { required: true, message: '活动名称不能为空', trigger: 'blur' }
          ],
          goodsId: [
            { required: true, message: '关联商品不能为空', trigger: 'blur' }
          ],
          coverImage: [
            { required: true, message: '活动封面不能为空', trigger: 'blur' }
          ],
          groupPrice: [
            { required: true, message: '拼团价不能为空', trigger: 'blur' }
          ],
          groupSize: [
            { required: true, message: '成团人数不能为空', trigger: 'blur' }
          ],
          totalStock: [
            { required: true, message: '总库存不能为空', trigger: 'blur' }
          ],
          activityTime: [
            { required: true, message: '活动时间不能为空', trigger: 'blur' }
          ]
        },
        // 弹出层标题
        title: '',
        // 是否显示弹出层
        open: false,
        // 是否显示详情弹出层
        detailOpen: false,
        // 详情数据
        detailData: null,
        // 当前激活的标签页
        activeTab: 'info'
      }
    },
    filters: {
      //时间格式化
      dateFormat(add_time) {
        if (add_time == undefined) {
          return "";
        }
        return moment(add_time*1000).format("YYYY-MM-DD HH:mm:ss");
      },
    },
    created() {
      this.DataList()
      this.getStats()
    },
    methods: {
      dateFormat(add_time) {
        if (add_time == undefined) {
          return "";
        }
        return moment(add_time*1000).format("YYYY-MM-DD HH:mm:ss");
      },
      // 新增：处理日期范围参数的方法
      addDateRange(params, dateRange) {
        const res = { ...params };
        // 仅当日期范围有有效值时才添加参数
        if (Array.isArray(dateRange) && dateRange.length === 2 && dateRange[0] && dateRange[1]) {
          res.start_date = dateRange[0]; // 对应后端接口的 start_date
          res.end_date = dateRange[1];   // 对应后端接口的 end_date
        }
        return res;
      },
      // 设置每页条数
      handleSizeChange(newSize) {
        this.queryParams.pageSize = newSize
        this.DataList()
      },
      // 分页跳转
      handleCurrentChange(newPage) {
        this.queryParams.pageNum = newPage
        this.DataList()
      },
      // 获取活动列表（修复后）
      DataList() {
        this.loading = true;
        // 先处理查询参数，添加日期范围
        // const requestParams = this.addDateRange({
        //   page: this.queryParams.pageNum,    // 对应后端的 page 参数
        //   pageSize: this.queryParams.pageSize, // 对应后端的 pageSize 参数
        //   keyword: this.queryParams.title,   // 对应后端的 keyword 参数
        //   status: this.queryParams.status !== undefined && this.queryParams.status !== ''
        //       ? this.queryParams.status
        //       : -1 // 后端默认 status=-1 表示全部
        // }, this.dateRange);

        const param = {
          access_token:sessionStorage.getItem('token'),
          company_id:sessionStorage.getItem('company_id'),
          pageNum: this.queryParams.pageNum,
          pageSize: this.queryParams.pageSize,
        }
        // 调用接口时传入处理后的参数
        this.$axios.getActivityListP(param).then(response => {
          this.activityList = response.data.data.map(item => ({
            ...item,
            timeRemain: this.getTimeRemain(item.endTime)
          }));
          this.total = response.data.total; // 对应后端返回的 total
          this.loading = false;
        }).catch(error => {
          console.error('获取活动列表失败：', error);
          this.loading = false;
          //this.$modal.msgError('获取活动列表失败，请重试');
        });
      },
      // 获取统计信息
      getStats() {
        this.$axios.getActivityStats().then(response => {
          this.stats = response.data
        })
      },

      // 搜索
      handleQuery() {
        this.queryParams.pageNum = 1
        this.DataList()
      },

      // 重置
      resetQuery() {
        this.dateRange = []
        this.resetForm('queryForm')
        this.handleQuery()
      },

      // 多选框选中数据
      handleSelectionChange(selection) {
        this.ids = selection.map(item => item.id)
        this.single = selection.length !== 1
        this.multiple = !selection.length
      },

      // 排序变化
      handleSortChange(column) {
        this.sortParams = {
          orderByColumn: column.prop,
          isAsc: column.order === 'ascending' ? 'asc' : 'desc'
        }
        this.DataList()
      },

      // 新增按钮操作
      handleAdd() {
       // this.reset()
        this.open = true
        this.title = '新增拼团活动'
      },

      // 修改按钮操作
      handleUpdate(row) {
        const activityId = row.id || this.ids

        const param = {
          access_token:sessionStorage.getItem('token'),
          company_id:sessionStorage.getItem('company_id'),
          id: activityId,
        }

        this.$axios.getActivity(param).then(response => {
          let tmp = response.data

          this.form.id=tmp.id;
          this.form.title=tmp.title;
          this.form.goodsId=tmp.goods_id;
          this.form.coverImage=tmp.cover_image;
          this.form.groupPrice=tmp.group_price;
          this.form.groupSize=tmp.group_size;
          this.form.validHours=tmp.valid_hours;
          this.form.limitNum=tmp.limit_num;
          this.form.totalStock=tmp.total_stock;
          this.form.virtualSales=tmp.virtual_sales;
          //     activityTime: [],
          //     skus: []




            // 关键修复：传入搜索关键词 query，让后端能根据输入筛选商品
            const param1 = {
              access_token: sessionStorage.getItem('token'),
              company_id: sessionStorage.getItem('company_id'),
              goods_id:tmp.goods_id,
              pageSize: 10,
            };
            this.$axios.getGroupGoodsListP(param1).then(response1 => {
              this.goodsOptions = response1.data?.data || [];
              // 获取商品信息
              if (this.form.goodsId) {
                this.handleGoodsChange(this.form.goodsId)
              }

              this.open = true
              this.title = '修改拼团活动'

            });



          this.form.activityTime = [this.dateFormat(response.data.start_time),this.dateFormat(response.data.end_time)]


        })
      },

      // 查看详情
      handleView(row) {
        this.$axios.getActivity(row.id, true).then(response => {
          this.detailData = response.data
          this.detailOpen = true

          // 渲染图表
          this.$nextTick(() => {
            this.renderOrderChart()
          })
        })
      },

      // 批量操作
      handleBatchCommand(command) {
        if (!this.ids.length) {
          this.$modal.msgWarning('请先选择活动')
          return
        }

        switch (command) {
          case 'batchStart':
            this.batchChangeStatus(1)
            break
          case 'batchPause':
            this.batchChangeStatus(3)
            break
          case 'batchEnd':
            this.batchChangeStatus(2)
            break
        }
      },

      // 状态操作
      handleStatusCommand(command, row) {
        let status, confirmText

        switch (command) {
          case 'start':
            status = 1
            confirmText = '开始'
            break
          case 'pause':
            status = 3
            confirmText = '暂停'
            break
          case 'end':
            status = 2
            confirmText = '结束'
            break
        }

        this.$confirm(`确认要${confirmText}该活动吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          return this.$axios.changeActivityStatus(row.id, status)
        }).then(() => {
          this.DataList()
          this.$modal.msgSuccess(`${confirmText}成功`)
        }).catch(() => {})
      },

      // 更多操作
      handleMoreCommand(command, row) {
        switch (command) {
          case 'teams':
            this.$router.push({
              path: 'groupTeamList',
              query: { activityId: row.id }
            })
            break
          case 'orders':
            this.$router.push({
              path: '/order/list',
              query: { activityId: row.id }
            })
            break
          case 'statistics':
            this.$router.push({
              path: '/activity/statistics',
              query: { id: row.id }
            })
            break
          case 'copy':
            this.handleCopy(row)
            break
        }
      },

      // 复制活动
      handleCopy(row) {
        this.$confirm('确认要复制该活动吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$axios.getActivity(row.id).then(response => {
            const activityData = response.data
            activityData.title = `${activityData.title} - 副本`
            activityData.id = undefined
            activityData.status = 0
            this.$axios.addActivity(activityData).then(res => {
              console.log(res)
              this.$modal.msgSuccess('复制成功')
              this.DataList()
            })
          })
        })
      },

      // 批量修改状态
      batchChangeStatus(status) {
        const statusText = {
          1: '开始',
          3: '暂停',
          2: '结束'
        }[status]

        this.$confirm(`确认要${statusText}选中的活动吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const requests = this.ids.map(id =>
                  this.$axios.changeActivityStatus(id, status)
          )
          return Promise.all(requests)
        }).then(() => {
          this.DataList()
          this.$modal.msgSuccess(`${statusText}成功`)
        }).catch(() => {})
      },

      // 删除按钮操作
      handleDelete(row) {
        const activityIds = row.id || this.ids
        this.$confirm('是否确认删除活动编号为"' + activityIds + '"的数据项？', '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          return this.$axios.delActivity(activityIds)
        }).then(() => {
          this.DataList()
          this.$modal.msgSuccess('删除成功')
        }).catch(() => {})
      },

      // 搜索商品（修复后）
      searchGoods(query) {
        if (query !== '') {
          this.goodsLoading = true;
          // 关键修复：传入搜索关键词 query，让后端能根据输入筛选商品
          const param = {
            access_token: sessionStorage.getItem('token'),
            company_id: sessionStorage.getItem('company_id'),
            title: query, // 新增：传入搜索关键词，对应后端的商品名称搜索
            pageSize: 10,
          };

          this.$axios.getGroupGoodsListP(param).then(response => {
            // 安全处理：确保返回数据是数组

            this.goodsOptions = response.data?.data || [];
            console.log('this.goodsOptions---',this.goodsOptions)
            this.goodsLoading = false;
          }).catch(error => {
            console.error('搜索商品失败：', error);
            this.goodsLoading = false;
            this.$message.error('商品搜索失败，请重试');
          });
        } else {
          // 输入为空时清空选项
          this.goodsOptions = [];
        }
      },

      // 商品选择变化
// 商品选择变化（修复后）
      handleGoodsChange(goodsId) {
        console.log('goodsId---',goodsId)
        if (!goodsId) {
          this.selectedGoods = null;
          this.skuList = [];
          return;
        }

        // 查找商品详情（添加容错：如果找不到匹配的商品，给出提示）
        const goods = this.goodsOptions.find(item => item.id === goodsId);
        console.log('goods---',goods)
        if (goods) {
          this.selectedGoods = goods;

          // 生成SKU列表（添加空值处理）
          if (goods.skus && Array.isArray(goods.skus) && goods.skus.length > 0) {
            this.skuList = goods.skus.map(sku => ({
              id: sku.id,
              specData: sku.specData || {},
              price: sku.price || 0,
              groupPrice: this.form.groupPrice || goods.groupPrice || 0,
              originalStock: sku.stock || 0,
              stock: Math.min(100, sku.stock || 0),
              status: 1
            }));
          } else {
            this.skuList = [];
          }

          // 设置默认拼团价（容错处理）
          if (!this.form.groupPrice) {
            this.form.groupPrice = goods.group_price || 0;
          }
          this.form.goodsId = goods.id;
        } else {
          // 找不到商品时的提示
         // this.$message.warning('未找到选中的商品信息，请重新选择');
          this.selectedGoods = null;
          this.skuList = [];
          this.form.goodsId = ''; // 清空选中值
        }
      },

      // 封面图片上传
      beforeCoverUpload(file) {
        const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
        const isLt2M = file.size / 1024 / 1024 < 2

        if (!isJPG) {
          this.$message.error('上传封面只能是 JPG/PNG 格式!')
        }
        if (!isLt2M) {
          this.$message.error('上传封面大小不能超过 2MB!')
        }
        return isJPG && isLt2M
      },

      handleCoverChange(file) {
        if (file.status === 'ready') {
          // 模拟上传，实际应该调用API
          this.form.coverImage = URL.createObjectURL(file.raw)
        }
      },

      // 获取剩余时间
      getTimeRemain(endTime) {
        if (!endTime) return ''

        const now = Date.now()
        const end = new Date(endTime).getTime()
        const diff = end - now

        if (diff <= 0) return '已结束'

        const days = Math.floor(diff / (1000 * 60 * 60 * 24))
        const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))

        if (days > 0) {
          return `${days}天${hours}小时`
        } else if (hours > 0) {
          return `${hours}小时${minutes}分`
        } else {
          return `${minutes}分钟`
        }
      },

      // 获取状态类型
      getStatusType(status) {
        const typeMap = {
          0: 'info',    // 未开始
          1: 'success', // 进行中
          2: 'danger',  // 已结束
          3: 'warning'  // 已暂停
        }
        return typeMap[status] || 'info'
      },

      // 获取状态文本
      getStatusText(status) {
        const textMap = {
          0: '未开始',
          1: '进行中',
          2: '已结束',
          3: '已暂停'
        }
        return textMap[status] || '未知'
      },

      // 获取进度条颜色
      getProgressColor(percentage) {
        if (percentage < 30) {
          return '#f56c6c'
        } else if (percentage < 70) {
          return '#e6a23c'
        } else {
          return '#67c23a'
        }
      },

      // 查看团队详情
      viewTeamDetail(team) {
        this.$router.push({
          path: '/activity/team-detail',
          query: { id: team.id }
        })
      },

      // 渲染订单趋势图
      renderOrderChart() {
        if (!this.$refs.orderChart) return

        // 模拟数据
        const chartData = {
          dates: ['12-01', '12-02', '12-03', '12-04', '12-05', '12-06', '12-07'],
          orders: [120, 132, 101, 134, 90, 230, 210],
          success: [110, 120, 90, 115, 80, 200, 180]
        }

        const chart = echarts.init(this.$refs.orderChart)
        const option = {
          tooltip: {
            trigger: 'axis'
          },
          legend: {
            data: ['订单数', '成团数']
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: chartData.dates
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              name: '订单数',
              type: 'line',
              smooth: true,
              data: chartData.orders,
              itemStyle: {
                color: '#36a3f7'
              },
              areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: 'rgba(54, 163, 247, 0.3)' },
                  { offset: 1, color: 'rgba(54, 163, 247, 0.1)' }
                ])
              }
            },
            {
              name: '成团数',
              type: 'line',
              smooth: true,
              data: chartData.success,
              itemStyle: {
                color: '#34bfa3'
              },
              areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: 'rgba(52, 191, 163, 0.3)' },
                  { offset: 1, color: 'rgba(52, 191, 163, 0.1)' }
                ])
              }
            }
          ]
        }

        chart.setOption(option)

        // 窗口大小改变时重绘图表
        window.addEventListener('resize', () => {
          chart.resize()
        })
      },

      // 取消按钮
      cancel() {
        this.open = false
        this.reset()
      },

      // 表单重置
      reset() {
        this.form = {
          id: undefined,
          title: undefined,
          goodsId: undefined,
          coverImage: undefined,
          groupPrice: undefined,
          groupSize: 2,
          validHours: 24,
          limitNum: 0,
          totalStock: 100,
          virtualSales: 0,
          activityTime: [],
          skus: []
        }
        this.selectedGoods = null
        this.skuList = []
        this.activeTab = 'info'
        this.resetForm('form')
      },

      // 提交表单
      submitForm() {
        this.$refs['form'].validate(valid => {
          if (valid) {
            // 处理时间数据
            if (this.form.activityTime && this.form.activityTime.length === 2) {
              this.form.startTime = this.form.activityTime[0]
              this.form.endTime = this.form.activityTime[1]
            }

            // 处理SKU数据
            this.form.skus = this.skuList.map(sku => ({
              skuId: sku.id,
              groupPrice: sku.groupPrice,
              stock: sku.stock,
              status: sku.status
            }))


                 let param= {
                   id: this.form.id,
                   title:this.form.title,
                   goods_id: this.form.goodsId,
                   cover_image: this.form.coverImage,
                   group_price: this.form.groupPrice,
                   group_size: this.form.groupSize,
                   valid_hours: this.form.validHours,
                   limit_num: this.form.limitNum,
                   total_stock: this.form.totalStock,
                   virtual_sales: this.form.virtualSales,
                   activity_time: this.form.activityTime,
                   skus: this.form.skus
                 }

            if (this.form.activityTime && this.form.activityTime.length === 2) {
              param.start_time = this.form.activityTime[0]; // 直接是 YYYY-MM-DD HH:mm:ss 格式
              param.end_time = this.form.activityTime[1];   // 直接是 YYYY-MM-DD HH:mm:ss 格式
            }

            param.access_token= sessionStorage.getItem('token');
            param.company_id= sessionStorage.getItem('company_id');

            console.log('form-----',param)
            if (param.id != null) {
              this.$axios.updateActivity(param).then(response => {
                console.log(response)
               // this.$modal.msgSuccess('修改成功')
                this.open = false
                this.DataList()
              })
            } else {
              this.$axios.addActivity(param).then(response => {
                console.log(response)
               // this.$modal.msgSuccess('新增成功')
               // this.open = false
                this.DataList()
              })
            }
          }
        })
      },

      // 导出
      handleExport() {
        this.download('/api/admin/activity/export', {
          ...this.queryParams,
          ...this.dateRange
        }, `activity_${new Date().getTime()}.xlsx`)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .app-container {
    padding: 20px;
  }

  .search-card {
    margin-bottom: 20px;
  }

  .stats-row {
    margin-bottom: 20px;

    .stats-card {
      height: 100px;

      .stats-content {
        display: flex;
        align-items: center;

        .stats-icon {
          width: 60px;
          height: 60px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 20px;

          i {
            font-size: 30px;
            color: white;
          }
        }

        .stats-info {
          flex: 1;

          .stats-title {
            font-size: 14px;
            color: #999;
            margin-bottom: 5px;
          }

          .stats-value {
            font-size: 24px;
            font-weight: bold;
            color: #333;
          }
        }
      }
    }
  }

  .operate-card {
    margin-bottom: 20px;
  }

  .table-card {
    .activity-cover {
      .cover-image {
        width: 80px;
        height: 80px;
        border-radius: 4px;
        overflow: hidden;
        cursor: pointer;

        .image-slot {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #f5f7fa;
          color: #909399;
          font-size: 24px;
        }
      }
    }

    .activity-title {
      .title-text {
        display: block;
        margin-bottom: 5px;
        font-weight: 500;
      }

      .goods-name {
        .el-tag {
          font-size: 12px;
        }
      }
    }

    .group-setting {
      text-align: center;

      .group-price {
        font-size: 18px;
        color: #f56c6c;
        font-weight: bold;
        margin-bottom: 5px;
      }

      .group-size {
        font-size: 14px;
        color: #666;
        margin-bottom: 3px;
      }

      .valid-hours {
        font-size: 12px;
        color: #999;
      }
    }

    .stock-sales {
      .stock-info {
        display: flex;
        justify-content: space-between;
        margin-top: 5px;
        font-size: 12px;
        color: #666;
      }
    }

    .group-data {
      .success-rate,
      .team-count,
      .success-count {
        display: flex;
        align-items: center;
        margin-bottom: 3px;
        font-size: 12px;
        color: #666;

        i {
          margin-right: 5px;
        }
      }

      .success-rate i {
        color: #67c23a;
      }

      .team-count i {
        color: #409eff;
      }

      .success-count i {
        color: #e6a23c;
      }
    }

    .activity-time {
      font-size: 12px;
      color: #666;

      .time-remain {
        margin-top: 5px;
      }
    }
  }

  .cover-uploader {
    ::v-deep .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;

      &:hover {
        border-color: #409eff;
      }
    }

    .cover-uploader-trigger {
      width: 300px;
      height: 150px;
      line-height: 150px;
      text-align: center;
      color: #8c939d;
      font-size: 12px;

      i {
        font-size: 28px;
        display: block;
        margin-top: 10px;
      }
    }

    .cover-image-preview {
      width: 300px;
      height: 150px;
      border-radius: 6px;
      object-fit: cover;
    }
  }

  .cover-tip {
    margin-top: 5px;
    color: #999;
    font-size: 12px;
  }

  .goods-option {
    display: flex;
    align-items: center;

    .goods-info {
      flex: 1;

      .goods-title {
        font-size: 14px;
        color: #333;
        margin-bottom: 5px;
      }

      .goods-price {
        font-size: 12px;
        color: #666;
      }
    }
  }

  .goods-detail {
    .goods-info {
      .goods-title {
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 10px;
        color: #333;
      }

      .goods-price {
        margin-bottom: 10px;

        .price-item {
          margin-bottom: 5px;

          .price-label {
            color: #666;
            margin-right: 5px;
          }

          .original-price {
            text-decoration: line-through;
            color: #999;
          }

          .current-price {
            color: #f56c6c;
          }

          .group-price {
            color: #e6a23c;
          }
        }
      }

      .goods-spec {
        margin-bottom: 10px;

        .spec-title {
          color: #666;
          margin-bottom: 5px;
        }

        .no-spec {
          color: #999;
          font-size: 12px;
        }
      }

      .goods-stock {
        display: flex;
        font-size: 14px;
        color: #666;
      }
    }
  }

  .no-goods {
    text-align: center;
    padding: 40px 0;
    color: #999;

    i {
      font-size: 40px;
      margin-bottom: 10px;
    }
  }

  .sku-spec {
    span {
      display: inline-block;
      padding: 2px 5px;
      background: #f5f7fa;
      border-radius: 3px;
      margin-right: 5px;
      font-size: 12px;
    }
  }

  .stock-tip {
    margin-top: 5px;
    color: #999;
    font-size: 11px;
  }

  .limit-tip,
  .sales-tip {
    margin-left: 10px;
    color: #999;
    font-size: 12px;
  }

  .required {
    color: #f56c6c;
    margin-right: 4px;
  }

  .activity-detail-dialog {
    .detail-section {
      margin-bottom: 30px;

      .section-title {
        margin-bottom: 15px;
        padding-bottom: 10px;
        border-bottom: 1px solid #eee;
        font-size: 16px;
        color: #333;
      }
    }

    .cover-container {
      border: 1px solid #eee;
      border-radius: 4px;
      padding: 5px;
    }

    .data-card {
      display: flex;
      align-items: center;
      padding: 15px;
      background: #fafafa;
      border-radius: 4px;

      .data-icon {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 15px;

        i {
          font-size: 24px;
          color: white;
        }
      }

      .data-content {
        flex: 1;

        .data-label {
          font-size: 14px;
          color: #666;
          margin-bottom: 5px;
        }

        .data-value {
          font-size: 22px;
          font-weight: bold;
          color: #333;
        }
      }
    }

    .leader-info {
      display: flex;
      align-items: center;
    }
  }

</style>
